import * as actionTypes from "./actionTypes";

export const getAllCourses = (courses, total) => {
  return {
    type: actionTypes.GET_ALL_COURSES,
    courses: courses,
    total: total,
  };
};

export const getCourse = (course) => {
  return {
    type: actionTypes.GET_COURSE,
    course: course,
  };
};

export const createCourse = (course) => {
  return {
    type: actionTypes.CREATE_COURSE,
    course: course,
  };
};

export const updateCourse = (course) => {
  return {
    type: actionTypes.UPDATE_COURSE,
    course: course,
  };
};

export const deleteCourse = (courseId) => {
  return {
    type: actionTypes.DELETE_COURSE,
    courseId: courseId,
  };
};

export const setCourseLoader = (loaderValue) => {
  return {
    type: actionTypes.SET_COURSE_LOADER,
    loaderValue: loaderValue,
  };
};

export const coursePageIncreament = () => {
  return {
    type: actionTypes.COURSE_PAGE_INCREAMENT,
  };
};

export const clearAllCourses = () => {
  return {
    type: actionTypes.CLEAR_ALL_COURSES,
  };
}; 

// My Courses Action Creators
export const getMyCourses = (courses, total) => {
  return {
    type: actionTypes.GET_MY_COURSES,
    courses: courses,
    total: total,
  };
};

export const setMyCoursesLoader = (loaderValue) => {
  return {
    type: actionTypes.SET_MY_COURSES_LOADER,
    loaderValue: loaderValue,
  };
};

export const myCoursesPageIncrement = () => {
  return {
    type: actionTypes.MY_COURSES_PAGE_INCREMENT,
  };
};

export const clearMyCourses = () => {
  return {
    type: actionTypes.CLEAR_MY_COURSES,
  };
}; 